<template>
  <el-dialog
      title="Добавление тэга"
      :visible.sync="$store.getters.articleTagCreateDialog"
      width="30%"
      :before-close="handleClose"
      
  >
    <el-form v-loading="isLoad">
      <el-form-item label="Название" >
        <el-input v-model="priceTypeForm.title" ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
    <el-button @click="$store.commit('articleTagCreateDialog',false)">Отмена</el-button>
    <el-button type="primary" :disabled="disableButton" @click="addTag">Добавить</el-button>
  </span>
  </el-dialog>
</template>

<script>
import axios from "axios";
import getErrors, { getTextErrors } from '../../composable/utils/getErrors';

export default {
  name: "CreateArticleTagDialog",
  props:['dialogVisible3'],
  data: function (){
    return{
      isLoad: false,
      priceTypeForm:{
        title:'',
      },
      tag: {}
    }
  },
  computed:{
    disableButton(){
      if(this.priceTypeForm.title === ''){
        return true;
      }
      else{
        return false;
      }
    }
  },
  methods:{
    handleClose() {
      this.priceTypeForm.title = '';
      this.$store.commit('articleTagCreateDialog',false);
    },

    addTag() {
      this.isLoad = true;
      axios.post("blog/tag", { title:  this.priceTypeForm.title })
      .then((response) => {
        this.tag = response.data
        this.savePriceType()
      })
      .catch((errors) => {
        if(errors.response.status === 422) {
          const err = getErrors(errors.response.data.errors)
          this.$notify.error(getTextErrors(err));
        }
      })
      .finally(() => this.isLoad = false);
    },

    savePriceType(){
      this.$emit('changeTag', this.tag)
      this.handleClose()
    },
  }
}
</script>

<style scoped>

</style>